<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.processId"
              />
            </a-form-item>
          </a-col>

        <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="设备">
              <j-search-select-tag
                :dict="
                  '`iwt-wf`.dev_list,dev_name,id' +
                    (queryParam.processId ? `,dev_process_id=${queryParam.processId} and del_flag=0` : ', del_flag=0') + 'order by sort asc'
                "
                @change="searchQuery"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="告警级别">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="alert_level"
                placeholder="告警级别"
                type="checkbox"
                v-model="queryParam.alertLevel"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="告警来源">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="alert_source"
                placeholder="告警级别"
                type="checkbox"
                v-model="queryParam.alertType"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="告警信息">
              <a-input @blur="searchQuery" allowClear placeholder="告警信息模糊查询" v-model="queryParam.summary"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('iot_alert_list')" icon="download" type="primary">导出</a-button>

      <a-tooltip title="卡片模式" v-show="!cardType">
        <a-button @click="cardType = true" icon="credit-card" style="margin-left: 20px"></a-button>
      </a-tooltip>

      <a-tooltip title="表格模式" v-show="cardType">
        <a-button @click="cardType = false" icon="table" style="margin-left: 20px" v-show="cardType"></a-button>
      </a-tooltip>
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchIgnore" key="1">
            <a-icon type="delete" />忽略
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>-->
    </div>

    <div v-show="!cardType">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            @click="previewFile(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="alertName" slot-scope="devId_dictText, record">
          {{
          record.alertName || record.devId_dictText || '工艺告警'
          }}
        </span>

        <template slot="alertName" slot-scope="devId_dictText, record">
          <a-button @click="devDetail(record)" size="small" type="link" v-if="record.devId">
            {{
            devId_dictText
            }}
          </a-button>
          <span v-if="!record.devId">{{ record.alertName || '其他告警' }}</span>
        </template>

        <span slot="levelSlot" slot-scope="text, record">
          <a-tag :color="$filterDictTextByCache('alert_level_color', text)">{{ record.alertLevel_dictText }}</a-tag>
        </span>

        <span slot="recoverySlot" slot-scope="text, record">
          <a-tag color="#ff4d4f" v-if="record.isRecovery == 0">未恢复</a-tag>
          <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>

        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, record">
          <a-tag color="gray" v-if="record.isAcknowledgement == 0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a :disabled="record.isAcknowledgement == 1" @click="acknowledgement(record)">确认</a>
          <a-divider type="vertical" />
          <a @click="ignore(record)">忽略</a>
          <!-- <a :disabled="record.isAcknowledgement == 0">转工单</a>-->
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a :disabled="!record.devId" @click="devDetail(record)">设备详情</a>
              </a-menu-item>
              <a-menu-item>
                <a :disabled="!record.pointCode" @click="dataLine(record)">数据曲线</a>
              </a-menu-item>
              <a-menu-item>
                <a :disabled="record.isAcknowledgement == 0" @click="defectRegister(record)">转缺陷</a>
              </a-menu-item>
              <a-menu-item v-if="record.alertType == 1">
                <a @click="handleWhiteModal(record)">加入白名单</a>
              </a-menu-item>

              <!-- handleWhiteModal -->
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <div v-show="cardType">
      <a-list
        :dataSource="dataSource"
        :grid="{ gutter: 24, lg: 4, md: 2, sm: 1, xs: 1 }"
        :pagination="{ ...paginationProps }"
      >
        <a-list-item slot="renderItem" slot-scope="record">
          <a-card
            :bodyStyle="{ height: '130px' }"
            :headStyle="{ 'text-align': 'center' }"
            :hoverable="true"
            :title="record.alertName || record.devId_dictText || '工艺告警'"
            size="small"
          >
            <span slot="extra">
              <a-tag :color="$filterDictTextByCache('alert_level_color', record.alertLevel)">
                {{
                record.alertLevel_dictText
                }}
              </a-tag>
            </span>

            <span slot="extra">
              <a-tag color="#ff4d4f" v-if="record.isRecovery == 0">未恢复</a-tag>
              <a-tag color="#52c41a" v-else>已恢复</a-tag>
            </span>

            <img
              :src="record.attachment || (record.devId ? devDefaulPng : processDefaulPng)"
              :style="{ height: '16vh', 'object-fit': 'contain' }"
              @click="previewFile(record.attachment)"
              alt="告警设备"
              slot="cover"
            />
            <a-card-meta :description="record.summary" :title="record.alertTime"></a-card-meta>
            <template slot="actions">
              <a>
                <a-button
                  :disabled="record.isAcknowledgement == 1"
                  @click="acknowledgement(record)"
                  size="small"
                  type="link"
                >确认</a-button>
              </a>
              <a-button @click="ignore(record)" size="small" type="link">忽略</a-button>
              <a>
                <a-dropdown>
                  <a class="ant-dropdown-link">
                    <a-icon type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a-button
                        :disabled="record.isAcknowledgement == 0"
                        @click="defectRegister(record)"
                        size="small"
                        type="link"
                      >转缺陷</a-button>
                    </a-menu-item>
                    <a-menu-item>
                      <a-button :disabled="!record.devId" @click="devDetail(record)" size="small" type="link">设备详情</a-button>
                    </a-menu-item>
                    <a-menu-item>
                      <a-button :disabled="!record.pointCode" @click="dataLine(record)" size="small" type="link">数据曲线</a-button>
                    </a-menu-item>
                    <a-menu-item v-if="record.alertType == 1">
                      <a-button @click="handleWhiteModal(record)" size="small" type="link">加入白名单</a-button>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <def-register-modal @ok="registerModalFormOk" ref="registerModalForm"></def-register-modal>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
    <iot-alert-whitelist-modal @ok="whiteMmodalOk" ref="whiteModalForm"></iot-alert-whitelist-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DefRegisterModal from '@views/equipment/defect/vue/modules/DefRegisterModal'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
  import devDefaulPng from '@/assets/dev.png'
  import processDefaulPng from '@/assets/process.jpg'
  import { httpAction, getAction } from '@/api/manage'
  import moment from 'dayjs'
  import { putAction } from '../../../api/manage'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import IotAlertWhitelistModal from '@views/alert/modules/IotAlertWhitelistModal'
  import { queryWhiteListByGroupCode } from '@/utils/h-request'
  export default {
    name: 'IotAlertList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DefRegisterModal,
      IotAlertWhitelistModal,
      PointsLineChartModal
    },
    data () {
      const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
      return {
        curItem: {},
        devDefaulPng: devDefaulPng,
        processDefaulPng: processDefaulPng,
        superQueryParams: JSON.stringify([{ rule: '=', type: 'string', dictCode: '', val: '0', field: 'disposal' }]),
        // 表头
        columns: [
          {
            title: '告警点',
            align: 'center',
            dataIndex: 'devId_dictText',
            scopedSlots: { customRender: 'alertName' }
          },
          {
            title: '告警时间',
            align: 'center',
            dataIndex: 'alertTime',
            customRender: forceNowrap,
            sorter: true
          },
          {
            title: '告警信息',
            align: 'center',
            dataIndex: 'summary',
            width: '300px',
            align: 'left'
          },
          {
            title: '告警等级',
            align: 'center',
            dataIndex: 'alertLevel',
            scopedSlots: { customRender: 'levelSlot' },
            sorter: true
          },
          {
            title: '是否确认',
            align: 'center',
            dataIndex: 'isAcknowledgement',
            scopedSlots: { customRender: 'isAcknowledgementSlot' },
            sorter: true
          },
          {
            title: '是否恢复',
            align: 'center',
            dataIndex: 'isRecovery_dictText',
            scopedSlots: { customRender: 'recoverySlot' },
            sorter: true
          },
          {
            title: '附件',
            align: 'center',
            dataIndex: 'attachment',
            scopedSlots: { customRender: 'imgSlot' },
            sorter: true
          },
          {
            title: '处理方式',
            align: 'center',
            dataIndex: 'disposal_dictText',
            customRender: forceNowrap,
            sorter: true
          },
          {
            title: '告警分类',
            align: 'center',
            dataIndex: 'alertType_dictText',
            customRender: forceNowrap,
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 165,
            scopedSlots: { customRender: 'action' }
          }
        ],
        ipagination: {
          current: 1,
          pageSize: 12,
          pageSizeOptions: ['12', '24', '36', '60', '120'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        url: {
          list: '/alert/iotAlert/list',
          delete: '/alert/iotAlert/delete',
          edit: '/alert/iotAlert/edit',
          deleteBatch: '/alert/iotAlert/deleteBatch',
          ignoreBatch: '/alert/iotAlert/ignoreBatch',
          exportXlsUrl: '/alert/iotAlert/exportXls',
          importExcelUrl: 'alert/iotAlert/importExcel'
        },
        cardType: false,
        dictOptions: {},
        superFieldList: [],
        isorter: {
          column: 'disposal',
          order: 'asc'
        }
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },

      paginationProps () {
        const _this = this
        return {
          ..._this.ipagination,
          onChange (page, pageSize) {
            _this.ipagination.pageSize = pageSize
            _this.ipagination.current = page
            _this.loadData()
          },
          onShowSizeChange (page, pageSize) {
            _this.ipagination.pageSize = pageSize
            _this.ipagination.current = page
            _this.loadData()
          }
        }
      }
    },
    methods: {
      async handleWhiteModal (record) {
        if (record.ruleGroupId) {
          const response = await queryWhiteListByGroupCode({ groupCode: record.ruleGroupId })
          if (response.success && response.result.records.length > 0) {
            return this.$message.warning('该告警已存在白名单')
          }
        }
        this.$refs.whiteModalForm.add(record)
        this.$refs.whiteModalForm.title = '告警白名单'
        this.$refs.whiteModalForm.disableSubmit = false
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() // 查询条件
        if (params.summary) {
          params.summary = `*${params.summary}*`
        }
        this.loading = true
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res.result.records || res.result
              if (res.result.total) {
                this.ipagination.total = res.result.total
              } else {
                this.ipagination.total = 0
              }
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      devDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.devId,
          type: 'drawer'
        })
      },
      acknowledgement (record) {
        record.isAcknowledgement = 1
        this.edit(record)
      },
      ignore (record) {
        record.isAcknowledgement = 1
        record.disposal = 'ignore'
        this.edit(record)
      },
      // TODO 批量忽略
      batchIgnore () {
        if (!this.url.ignoreBatch) {
          this.$message.error('请设置url.ignoreBatch属性!')
          return
        }
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          var ids = ''
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ','
          }
          var that = this
          this.$confirm({
            title: '确认忽略',
            content: '是否忽略选中告警?',
            onOk: function () {
              that.loading = true
              putAction(that.url.ignoreBatch, { ids: ids })
                .then(res => {
                  if (res.success) {
                    // 重新计算分页问题
                    that.reCalculatePage(that.selectedRowKeys.length)
                    that.$message.success(res.message)
                    that.loadData()
                    that.onClearSelected()
                  } else {
                    that.$message.warning(res.message)
                  }
                })
                .finally(() => {
                  that.loading = false
                })
            }
          })
        }
      },
      edit (record) {
        httpAction(this.url.edit, record, 'put').then(res => {
          if (res.success) {
            this.modalFormOk()
            this.$message.success('处理成功!')
          } else {
            that.$message.warning('处理失败!,请联系管理员')
          }
        })
      },
      whiteMmodalOk () { },
      handleDetail (record) {
        const ref = 'modalFormDetail'
        this.$refs[ref].edit(record)
        this.$refs[ref].title = '详情'
        this.$refs[ref].disableSubmit = true
      },
      dataLine (record) {
        const timeRange = [
          moment(record.alertTime)
            .add(-1, 'hours')
            .format('YYYY-MM-DD HH:mm'),
          moment(record.alertTime)
            .add(1, 'hours')
            .format('YYYY-MM-DD HH:mm')
        ]
        const pointCode = record.pointCode
        const alertTime = record.alertTime
        let marks

        if (record.alertValue) {
          marks = {
            markPoints: {},
            markLines: {}
          }
          const alertValArr = record.alertValue.split(';')
          for (let index = alertValArr.length - 1; index >= 0; index--) {
            const valStr = alertValArr[index]

            if (!valStr.includes('{')) {
              return
            }
            const color =
              filterDictTextByCache('alert_level_color', parseInt(record.alertLevel) + alertValArr.length - 1 - index) ||
              'red'
            const valueMap = JSON.parse(valStr)
            const xAxis = valueMap.time
            const pointVals = JSON.parse(valueMap.value)

            const markLine = {
              name: '告警时刻',
              xAxis: xAxis,
              itemStyle: {
                color: color
              },
              lineStyle: {
                type: 'solid'
              },
              label: {
                //  label属性 设置图线的样式
                show: false
              }
            }
            for (const pointCode in pointVals) {
              if (Object.hasOwnProperty.call(pointVals, pointCode)) {
                const pVal = pointVals[pointCode]

                const markPoint = {
                  name: '告警时刻',
                  yAxis: pVal,
                  xAxis: xAxis,
                  value: pVal,
                  itemStyle: {
                    color: color
                  }
                }
                marks.markPoints[pointCode]
                  ? marks.markPoints[pointCode].push(markPoint)
                  : (marks.markPoints[pointCode] = [markPoint])
                marks.markLines[pointCode]
                  ? marks.markLines[pointCode].push(markLine)
                  : (marks.markLines[pointCode] = [markLine])
              }
            }
          }
        }
        this.$refs.pointsDataLineModal.show(pointCode, timeRange, alertTime, 'noValue', marks)
      },
      defectRegister (record) {
        this.curItem = record
        this.$refs.registerModalForm.add(record.devId)
        this.$refs.registerModalForm.title = '登记缺陷'
        this.$refs.registerModalForm.disableSubmit = false
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'int', value: 'groupId', text: '小组编号' })
        fieldList.push({ type: 'int', value: 'alertGroupId', text: '预警分组编号' })
        fieldList.push({ type: 'string', value: 'groupName', text: '小组名称' })
        fieldList.push({ type: 'string', value: 'alertName', text: '告警名称' })
        fieldList.push({ type: 'string', value: 'ruleId', text: '规则id' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '测点点号' })
        fieldList.push({ type: 'string', value: 'devId', text: '传感器Sn码' })
        fieldList.push({ type: 'string', value: 'processId', text: '供水流域id' })
        fieldList.push({ type: 'date', value: 'alertTime', text: '告警时间' })
        fieldList.push({ type: 'string', value: 'summary', text: '告警信息' })
        fieldList.push({ type: 'int', value: 'alertType', text: '告警分类(测点采集、视频识别、音频识别)' })
        fieldList.push({ type: 'string', value: 'attachment', text: '附件文件id（图片、视频、音频等）' })
        fieldList.push({ type: 'int', value: 'alertLevel', text: '预警等级' })
        fieldList.push({ type: 'int', value: 'isAcknowledgement;', text: '是否被处理' })
        fieldList.push({ type: 'int', value: 'disposal', text: '处理方式' })
        fieldList.push({ type: 'int', value: 'isRecovery', text: '是否恢复' })
        this.superFieldList = fieldList
      },
      toOtherPage (route) {
        this.$router.push({
          path: route
        })
      },
      registerModalFormOk (defRegisterId) {
        console.log(defRegisterId)
        this.curItem.disposal = 'defect'
        this.edit(this.curItem)
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

  .ant-card-meta-detail {
    overflow: hidden;
    height: 100px;
  }

</style>
